import type { TenantConfig } from '@/types/TenantConfig'

const blue = '#2222FF'

export const grayarea: TenantConfig = {
  logo: 'assets/grayarea/static/logo.svg',
  teaserImageSize: {
    width: 320,
  },
  themeOptions: {
    primaryColor: blue,
    secondaryColor: blue,
    headerBackground: 'linear-gradient(to bottom right,#232323, #454545)',
    footerBackgroundColor: 'transparent',
    cartHeaderBackgroundColor: '#E5E5E5',
    cartHeaderTextColor: '#555555',
    logoHeight: '26px',
    pageBackgroundColor: 'linear-gradient(#FFFFFF, #B7BDFC)',
    memberLinksColor: 'white',
    memberLinksColorHover: '#E5E5E5',
  },
  componentOptions: {
    stripeCreditCard: {
      fontFaceStylesheet: 'https://use.typekit.net/tsu4pxd.css',
    },
    completedOrdersRoute: {
      completedImage: {
        desktop: 'assets/grayarea/static/completed.webp',
      },
      completedContentOffset: {
        desktop: '-200px',
        mobile: '-120px',
      },
    },
  },
}
